



























































































































  import JobDetails from '@/components/Jobdetails.vue';
  import pdf from 'vue-pdf';
  import { Job } from '@/models/jobs/job'; 
import { vxm } from '../../../store.vuex';
  export default {
    name: 'offerLetterPopUp',
  components: {
    pdf,
  },
  data(){
    return {
        intermidateJobId:0,
        onShowReasonCodes:false,
    }
  },
    props: {
      header: {
        default: '',
        type: String,
      },
      body: {
        default: '',
        type: String,
      },
      offerLetterUrl: {
        default: '',
        type: String,
      },
      disableButtons: {
        default: false,
        type: Boolean,
      },
      docGuid:{
        default: '',
        type: String,
      },
      reasonCodes: {
          default: [],
          type: Array,
        },
        rejectOffer: {
        type: Function,
        default: () => {},
      },
      acceptOffer: {
        type: Function,
        default: () => {},
      },
    job: {
        type: Job,
        default: new Job(),
      },
      reasonCodeOnReject: {
        type: Function,
        default: () => {},
      },
      onCancel: {
      default: () => {},
      type: Function,
    },
    
    },
    methods: {
        reasonCodetestReject(job) {
            (this as any).intermidateJobId=job.jobPostingId,
            (this as any).onShowReasonCodes=true
    },
    clickToCloseList(){
        (this as any).intermidateJobId=0,
            (this as any).onShowReasonCodes=false,
            (this as any).job.comment='',
            (this as any).job.reasonCodeId=-1
  
    },
    async downloadResume(fileGUID, name) {
    try {
      const authToken = vxm.users.getToken;
      const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + fileGUID;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`, 
        },
      });
      
      if (!response.ok) {
        throw new Error('Failed to download resume');
      }
      
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = name || 'OfferLetter';
      
      // Trigger a click event to initiate the download
      link.click();
      
      // Clean up the URL object after download
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading resume:', error);
    }
  }
    },
  
  mounted(){          
    }
  }
  
